import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useAssignSettingSelfServeBrandInstantAnswers, useSettingSelfServeBrandInstantAnswers } from "@faire/help-center-utils/settings/useSettingSelfServiceBrandInstantAnswers";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Storefront } from "@faire/web--source/slate/icons/foundation/Storefront";
import React from "react";
import { AboutAnalytics } from "../instantAnswers/myShop-aboutAnalytics";
import { CustomerServiceAnalytics } from "../instantAnswers/myShop-customerServiceAnalytics";
import { DisputeReview } from "../instantAnswers/myShop-disputeReview";
import { InternationalOrderSettings } from "../instantAnswers/myShop-internationalOrderSettings";
import { OnlineOnlyRetailers } from "../instantAnswers/myShop-onlineOnlyRetailers";
import { OrderMinimums } from "../instantAnswers/myShop-orderMinimums";
import { PauseShop } from "../instantAnswers/myShop-pauseShop";
import { RequestReview } from "../instantAnswers/myShop-requestReview";
import { ScheduledOrders } from "../instantAnswers/myShop-scheduledOrders";
import { ShopAboutSection } from "../instantAnswers/myShop-shopAboutSection";
import { ShopImagery } from "../instantAnswers/myShop-shopImagery";
import { ShopLeadTime } from "../instantAnswers/myShop-shopLeadTime";
export var useMyShopBrandNodes = function useMyShopBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var enableSettingSelfServeBrandInstantAnswers = useSettingSelfServeBrandInstantAnswers();
  var assignSettingSelfServeBrandInstantAnswers = useAssignSettingSelfServeBrandInstantAnswers();
  var articles = useArticles();
  var commonFields = {
    id: "MyShop",
    label: strictLocalize({
      id: "p4WAW6",
      defaultMessage: "Manage shop"
    }),
    icon: /*#__PURE__*/React.createElement(Storefront, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    level: 1,
    assignSetting: assignSettingSelfServeBrandInstantAnswers,
    sidebarTitle: strictLocalize({
      id: "GZDCqb",
      defaultMessage: "Shop issue"
    })
  };
  if (!enableSettingSelfServeBrandInstantAnswers) {
    return {
      MyShop: _objectSpread(_objectSpread({}, commonFields), {}, {
        children: ["Settings", "OtherMyShop"]
      }),
      Settings: {
        id: "Settings",
        label: strictLocalize({
          id: "iyytHb",
          defaultMessage: "Settings"
        }),
        level: 2
      },
      OtherMyShop: {
        id: "OtherMyShop",
        label: OTHER_NODES_LABEL(strictLocalize),
        articles: [articles.OptimizingMyPage.PRODUCT_PHOTOGRAPHY_GUIDELINES, articles.OptimizingMyPage.BRAND_STORY_GUIDELINES, articles.OptimizingMyPage.ADD_VIDEO],
        level: 2
      }
    };
  }
  return {
    MyShop: _objectSpread(_objectSpread({}, commonFields), {}, {
      children: ["Analytics", "CustomerReviews", "ShopPage", "ShopPreferences"],
      shouldStopAddingDefaultOtherNodeToChildren: true
    }),
    Analytics: {
      id: "Analytics",
      label: strictLocalize({
        id: "Hwxr4e",
        defaultMessage: "Analytics"
      }),
      children: ["AboutAnalytics", "CustomerServiceAnalytics"],
      level: 2
    },
    CustomerReviews: {
      id: "CustomerReviews",
      label: strictLocalize({
        id: "Bt+JGX",
        defaultMessage: "Customer reviews"
      }),
      children: ["RequestReview", "DisputeReview"],
      level: 2
    },
    ShopPage: {
      id: "ShopPage",
      label: strictLocalize({
        id: "6P1nVk",
        defaultMessage: "Shop page"
      }),
      children: ["ShopImagery", "ShopAboutSection"],
      level: 2
    },
    ShopPreferences: {
      id: "ShopPreferences",
      label: strictLocalize({
        id: "Npp87B",
        defaultMessage: "Shop preferences"
      }),
      children: ["OrderMinimums", "InternationalOrderSettings", "ScheduledOrders", "ShopLeadTime", "OnLineOnlyRetailers", "PauseShop"],
      level: 2
    },
    AboutAnalytics: {
      id: "AboutAnalytics",
      label: strictLocalize({
        id: "d62nEt",
        defaultMessage: "About analytics"
      }),
      instantAnswer: AboutAnalytics(strictLocalize),
      articles: [articles.ManageMyShop.SHOP_PERFORMANCE_ANALYTICS],
      level: 3
    },
    CustomerServiceAnalytics: {
      id: "CustomerServiceAnalytics",
      label: strictLocalize({
        id: "v1mc5n",
        defaultMessage: "Customer service analytics"
      }),
      instantAnswer: CustomerServiceAnalytics(strictLocalize),
      articles: [articles.ManageMyShop.SHOP_PERFORMANCE_ANALYTICS],
      level: 3
    },
    RequestReview: {
      id: "RequestReview",
      label: strictLocalize({
        id: "zY6+/H",
        defaultMessage: "Request a review"
      }),
      instantAnswer: RequestReview(strictLocalize),
      articles: [articles.ManageMyShop.BUILDING_POSITIVE_REPUTATION],
      level: 3
    },
    DisputeReview: {
      id: "DisputeReview",
      label: strictLocalize({
        id: "hnCNrA",
        defaultMessage: "Dispute a review"
      }),
      instantAnswer: DisputeReview(strictLocalize),
      articles: [articles.ManageMyShop.WHAT_TO_DO_IF_NEGATIVE_REVIEW, articles.ManageMyShop.SHOP_PERFORMANCE_ANALYTICS],
      level: 3
    },
    ShopImagery: {
      id: "ShopImagery",
      label: strictLocalize({
        id: "7/2xqT",
        defaultMessage: "Shop imagery"
      }),
      instantAnswer: ShopImagery(strictLocalize),
      articles: [articles.OptimizingMyPage.FEATURE_IMAGE_GUIDELINES, articles.OptimizingMyPage.COVER_IMAGE_GUIDELINES, articles.OptimizingMyPage.BRAND_STORY_GUIDELINES],
      level: 3
    },
    ShopAboutSection: {
      id: "ShopAboutSection",
      label: strictLocalize({
        id: "RQFAOi",
        defaultMessage: "Shop about section"
      }),
      instantAnswer: ShopAboutSection(strictLocalize),
      articles: [articles.OptimizingMyPage.BRAND_STORY_GUIDELINES, articles.ManageMyShop.WHAT_ARE_BRAND_TAGS],
      level: 3
    },
    OrderMinimums: {
      id: "OrderMinimums",
      label: strictLocalize({
        id: "HTW9ou",
        defaultMessage: "Order minimums"
      }),
      instantAnswer: OrderMinimums(strictLocalize),
      articles: [articles.ManageMyShop.WHAT_ARE_LEAD_TIMES, articles.International.LOCATION_SHOP_LIVE],
      level: 3
    },
    InternationalOrderSettings: {
      id: "InternationalOrderSettings",
      label: strictLocalize({
        id: "qp8KdC",
        defaultMessage: "International order settings"
      }),
      instantAnswer: InternationalOrderSettings(strictLocalize),
      articles: [articles.International.LOCATION_SHOP_LIVE],
      level: 3
    },
    ScheduledOrders: {
      id: "ScheduledOrders",
      label: strictLocalize({
        id: "4OgJZK",
        defaultMessage: "Scheduled orders"
      }),
      instantAnswer: ScheduledOrders(strictLocalize),
      articles: [articles.FulfillingOrders.FULFILLING_SCHEDULED_ORDERS],
      level: 3
    },
    ShopLeadTime: {
      id: "ShopLeadTime",
      label: strictLocalize({
        id: "Vb8AOc",
        defaultMessage: "Shop lead time"
      }),
      instantAnswer: ShopLeadTime(strictLocalize),
      articles: [articles.ManageMyShop.WHAT_ARE_LEAD_TIMES],
      level: 3
    },
    OnLineOnlyRetailers: {
      id: "OnLineOnlyRetailers",
      label: strictLocalize({
        id: "m9p2Er",
        defaultMessage: "Online-only retailers"
      }),
      instantAnswer: OnlineOnlyRetailers(strictLocalize),
      articles: [articles.ManageMyShop.WHAT_ARE_SOCIAL_SELLERS],
      level: 3
    },
    PauseShop: {
      id: "PauseShop",
      label: strictLocalize({
        id: "lcnyyb",
        defaultMessage: "Pause shop"
      }),
      instantAnswer: PauseShop(strictLocalize),
      articles: [articles.ManageMyShop.HOW_DO_I_CLOSE_MY_SHOP],
      level: 3
    }
  };
};